<template>
  <div
    class="min-h-screen flex flex-col sm:justify-center items-center p-6 sm:pt-0"
  >
    <figure class="mb-6">
      <router-link to="/">
        <hgroup class="text-center">
          <h1 class="text-4xl tracking-widest">TABASCO</h1>
          <h2 class="text-xl tracking-widest">Sauce Industries</h2>
        </hgroup>
      </router-link>
    </figure>
    <main class="w-full sm:max-w-md">
      <router-view></router-view>
    </main>
  </div>
</template>
